// FullReportCards.js
import React from "react";
import { useNavigate } from "react-router-dom";
import "../components/FullReport.css";

// Sample reports
const reports = [
  { id: 1, patientName: "John Doe", diagnosis: "Flu and Cold", visitDate: "2025-09-18" },
  { id: 2, patientName: "Jane Smith", diagnosis: "Headache", visitDate: "2025-09-17" },
  { id: 3, patientName: "Alex Johnson", diagnosis: "Diabetes", visitDate: "2025-09-16" },
  { id: 4, patientName: "Mary Lee", diagnosis: "Blood Pressure", visitDate: "2025-09-15" },
  { id: 5, patientName: "Robert Brown", diagnosis: "General Checkup", visitDate: "2025-09-14" },
];

const FullReportCards = () => {
  const navigate = useNavigate();

  return (
    <div className="full-report-container">
      <h2>Patient Reports</h2>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "20px" }}>
        {reports.map((report) => (
          <div
            key={report.id}
            className="report-card"
            style={{ cursor: "pointer" }}
            onClick={() => navigate(`/report/${report.id}`)}
          >
            <div className="report-item">
              <span className="label">Patient:</span>
              <span className="value">{report.patientName}</span>
            </div>
            <div className="report-item">
              <span className="label">Diagnosis:</span>
              <span className="value">{report.diagnosis}</span>
            </div>
            <div className="report-item">
              <span className="label">Date:</span>
              <span className="value">{report.visitDate}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FullReportCards;
